export const setSendingProtoTasksSucceded = (): Function => (state): void => {
  const selectedItemIDs = state[state.scheduling.from].selected.map(
    item => item.id,
  );

  return {
    ...state,
    [state.scheduling.from]: {
      ...state[state.scheduling.from],
      items: state[state.scheduling.from].items.filter(
        item => !selectedItemIDs.includes(item.id),
      ),
      selected: [],
    },
    scheduling: {
      ...state.scheduling,
      done: true,
      lastFetch: {
        failed: false,
        reason: { message: "" },
      },
      sending: false,
    },
  };
};
